import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { statusTranslate } from "../../utils/advanceRequest";
import { STATUS_SHORT_LABEL } from "../../utils/mergeSelection";

const SHORT: Record<string, string> = { ...STATUS_SHORT_LABEL, done: "Antecipado", canceled: "Cancelada", expired: "Expirado" };

export const STATUS_META: Record<string, { label: string; bg: string; fg: string }> = {
  waiting_supplier_company_input_vacancies_data: { label: SHORT.waiting_supplier_company_input_vacancies_data, bg: "#eef2f6", fg: "#475569" },
  waiting_generate_doctor_contract: { label: SHORT.waiting_generate_doctor_contract, bg: "#e0f7fc", fg: "#036b84" },
  waiting_doctor_sign_contract: { label: SHORT.waiting_doctor_sign_contract, bg: "#fff4e0", fg: "#8a5200" },
  waiting_payment_doctor: { label: SHORT.waiting_payment_doctor, bg: "#ede9fe", fg: "#5b21b6" },
  done: { label: SHORT.done, bg: "#e6f4ea", fg: "#1e6b34" },
  canceled: { label: SHORT.canceled, bg: "#fdecec", fg: "#a32020" },
  merged: { label: SHORT.merged, bg: "#f1f1f4", fg: "#555555" },
  expired: { label: SHORT.expired, bg: "#fff1e6", fg: "#9a3412" },
};

export default function StatusChip({ status }: { status: string }) {
  const full = String(statusTranslate(status));
  const meta = STATUS_META[status] ?? { label: full, bg: "#f1f2f4", fg: "#374151" };
  return (
    <Tooltip title={full} placement="top">
      <Chip size="small" label={meta.label} data-status={status} data-testid={`status-chip-${status}`} sx={{ bgcolor: meta.bg, color: meta.fg, height: 24, fontSize: 12, fontWeight: 500 }} />
    </Tooltip>
  );
}
